import React from "react";
import CTable from "components/common/Table";
import Link from "components/common/Link";
import { withRouter } from "react-router";
import Switch from "components/common/Switch";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";

const contact = ({ data, loading, handleStatusManufacturer }) => {
  const columns = [
    {
      field: "name",
      headerName: "Name",
    },
    {
      field: "mobile",
      headerName: "Mobile",
    },

    {
      field: "email",
      headerName: "Email",
    },
    {
      field: "pin",
      headerName: "PIN",
    },
    {
      field: "query",
      headerName: "Query",
    },  

    // {
    //   field: "action",
    //   headerName: "Action",
    //   valueGetter: (v, d) => {
    //     const manufacturer = {
    //       pathname: "/view/details",
    //       manufacturerDetailsId: { id: d.manufacturer_id, name: d.name },
    //     };
    //     return (
    //       <>
    //         {
    //           <>
    //             <Link style={{ textDecoration: "none" }} href={manufacturer}>
    //               <VisibilityOutlinedIcon
    //                 sx={{
    //                   opacity: "0.8",
    //                   width: "40%",
    //                   marginTop: "3px",
    //                   marginBottom: "-10px",
    //                 }}
    //               />
    //             </Link>
    //           </>
    //         }

    //         {
    //           <Switch
    //             checked={d.status === 1 ? true : false}
    //             onClick={() =>
    //               handleStatusManufacturer(d.manufacturer_id, d.status)
    //             }
    //           />
    //         }
    //       </>
    //     );
    //   },
    // },
  ];

  return (
    <CTable
      columns={columns}
      data={data}
    //   isLoading={loading?.isLoading}
      pagination={true}
      localPagination={true}
      page={0}
      rowsPerPage={5}
    ></CTable>
  );
};

export default withRouter(contact);

